var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMapLayers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.551 13.165l1 .661a1 1 0 01-.114 1.734l-11 5.34a1.001 1.001 0 01-.874 0l-11-5.34a1 1 0 01-.114-1.734l1-.66a1 1 0 011.438 1.297L12 18.888l9.114-4.424a1.001 1.001 0 011.437-1.299zM12.48 2.122l11 6a1 1 0 010 1.756l-11 6a1.003 1.003 0 01-.957 0l-11-6a1 1 0 010-1.756l11-6a.998.998 0 01.957 0zM12 4.14L3.09 9 12 13.861l8.912-4.86L12 4.138z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconMapLayers;